
import Vue from 'vue'
import AppActions from '~/domain/constants/AppActions'
import { UserType } from '@interfaces/UserTypes'

export default Vue.extend({
  name: 'CommunityFollowBtn',
  props: {
    designer: {
      type: Object,
    },
    styleRoundBtnNoText: {
      type: Boolean,
      default: false,
    },
    stateOnHover: {
      type: Boolean,
      default: false,
    },
    allowAction: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isLoading: false,
      isLoadingComplete: false,

      followerCount: 0,
      isChangingValue: false,
    }
  },
  computed: {
    isFollowed() {
      return (this.designer as UserType)?.isFollowed || false
    },
    objForFollowProp(this: any) {
      return {
        designerId: this.designer?.id,
        isFollowed: this.isFollowed,
        followerCount: {
          text: 'Followers',
          count: +this.followerCount,
        },
        icons: {
          follow: {
            icon: '$followIcon',
            text: `${this.$t('followCapital')}`,
          },
          unfollow: {
            icon: '$unfollowIcon',
            text: `${this.$t('unfollowCapital')}`,
          },
          followed: {
            icon: '$followedIcon',
            text: `${this.$t('followingCapital')}`,
          },
          starIcon: '$starIconOrange',
        },
        styleRoundBtnNoText: this.styleRoundBtnNoText,
        stateOnHover: this.stateOnHover,
        isLoading: this.isLoading,
        dataChanged: this.isChangingValue,
      }
    },
    user() {
      return this.$store.getters['authenticatedUser']
    },
    userIsAuthenticated() {
      return this.$store.getters['userIsAuthenticated']
    },
    equalsAuthenticatedUser() {
      return this.$store.getters[`community/equalsAuthenticatedUser`]
    },
    btnStyle(): any {
      if (this.isFollowed) {
        return {
          color: 'var(--v-primary-base)',
          styleRoundBtnNoText: this.styleRoundBtnNoText,
          stateOnHover: true,
          squareButton: false,
        }
      }

      // not followed
      return {
        color: 'var(--v-primary-base)',
        styleRoundBtnNoText: this.styleRoundBtnNoText,
        stateOnHover: true,
        squareButton: false,
      }
    },
  },
  methods: {
    async followUser(designer: UserType): Promise<void> {
      const isFollowed = !designer?.isFollowed
      await this.$store.dispatch(AppActions.FOLLOW_DESIGNER, {
        designer,
        isFollowed,
        context: {
          ...this.$nuxt.context,
          $route: this.$route,
        },
      })
    },
  },
})
